import * as React from 'react';
import styled from 'styled-components';

const SLabel = styled.span`
    display: inline-block;
`;
interface IInput {
    id?: string;
    label: string;
    name: string;
    className: string;
    isSelected: boolean;
    isDisabled?: boolean;
    value?: string;
    onChange?: (e:any) => void;
}

export class Radio extends React.Component<IInput> {
    public render(){
        return ( 
           <div className={this.props.className}>
                <label><input
                    type="radio"
                    name={this.props.name}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    checked={this.props.isSelected}
                    disabled={this.props.isDisabled}
                /> <SLabel>{this.props.label}</SLabel> </label>
            </div>
        );
    }
};
